import { apiFetch } from "@/hooks/apiFetch"

export const fetchCustomers = async (
  { page = 1, searchQuery = "", perPage = 30 },
  signal?: AbortSignal
) =>
  apiFetch(
    `customer?page=${page}&per_page=${perPage}&sort_order=asc&search=${searchQuery}`,
    {
      signal,
    }
  )
